import React from 'react';

import { useTranslation } from 'react-i18next';

import { itemByLanguage } from '@/utils/language';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

import { Plan } from '@/_generated/api-clients/xp';

interface RemovePlanProps {
  isLoading?: boolean;
  onRemove: () => void;
  plan: Plan;
  setShowRemovePlan: (show: boolean) => void;
  showRemovePlan: boolean;
}

const RemovePlan: React.FC<RemovePlanProps> = ({
  isLoading,
  onRemove,
  plan,
  setShowRemovePlan,
  showRemovePlan,
}) => {
  const { t } = useTranslation();

  const planName = itemByLanguage(plan.name) ?? '';

  return (
    <ConfirmationModal
      bodyText={t('Settings.removePlanModal.body', { planName })}
      headerText={t('Settings.removePlanModal.title')}
      isOpen={showRemovePlan}
      isLoading={isLoading}
      onClose={() => setShowRemovePlan(false)}
      primaryButtonHandler={() => {
        onRemove();
      }}
      primaryButtonText={t('Button.remove')}
      primaryButtonVariant="destructive"
      secondaryButtonHandler={() => setShowRemovePlan(false)}
      secondaryButtonText={t('Button.cancel')}
    />
  );
};

export default RemovePlan;
